module.exports = __webpack_public_path__ + "static/media/tracey.dfedec00.png";